import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { records as getCards } from "../../../services/card";
import { create } from "../../../services/billing";
import LoadingData from "../../utilities/LoadingData";

class PayModel extends Component {
    state = {
        items: [],
        errors: {},
        loading: false
    };

    componentDidMount() {
        getCards()
            .then(res => {
                this.setState({ items: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    pay = card => {
        this.setState({ loading: true });
        create({
            card_id: card,
            type: "jobListing",
            coupon:
                this.context.state.coupon.discount >= 1
                    ? this.context.state.coupon.id
                    : 0
        })
            .then(res => {
                this.setState({ loading: false });
                this.props.hidePay();
            })
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    render() {
        return (
            <Fragment>
                <div className="model-container model-center model-backdrop-show">
                    {this.state.loading ? (
                        <LoadingData></LoadingData>
                    ) : (
                        <div
                            aria-labelledby="model-title"
                            aria-describedby="model-content"
                            className="model-popup model-modal model-show"
                            role="dialog"
                            aria-live="assertive"
                            aria-modal="true"
                        >
                            <div className="model-header paymentModelHeader">
                                <img
                                    src="/images/paymentModel.png"
                                    alt=""
                                ></img>
                            </div>
                            <h2 className="model-title" id="model-title">
                                {this.props.planDesc}
                            </h2>
                            <div className="model-content">
                                <div className="m-2 text-center">
                                    <div className="price">
                                        {this.context.state.coupon.discount >=
                                        1 ? (
                                            <p>
                                                        {this.props.planPrice -
                                                    parseFloat(
                                                        parseFloat(
                                                            (this.props.planPrice /
                                                                100) *
                                                                this.context
                                                                    .state
                                                                    .coupon
                                                                    .discount
                                                        )
                                                    ).toFixed(0)}

                                                <span className="discount">
                                                    $
                                                            {this.props.planPrice }
                                                </span>
                                            </p>
                                        ) : (
                                            <p>
                                                        {this.props.planPrice }
                                            </p>
                                        )}
                                    </div>

                                    <small>
                                        {
                                                this.props.planDesc
                                        }
                                    </small>
                                    <img
                                        alt="add gift coupon"
                                        onClick={this.props.showAddCoupon}
                                        className="couponIcon"
                                        src="/images/couponIcon.png"
                                    ></img>
                                </div>

                                <ul
                                    id="cardsContent"
                                    className="list-group list-group-flush list m-3"
                                >
                                    {this.state.items.map((item, index) => {
                                        return (
                                            <li
                                                key={index}
                                                className="list-group-item px-0"
                                            >
                                                <div className="row align-items-center">
                                                    <div className="col-auto">
                                                        <a href="">
                                                            <img
                                                                src={`/cards/${item.type}.png`}
                                                                className="cc-image-lg"
                                                                alt=""
                                                            ></img>
                                                        </a>
                                                    </div>
                                                    <div className="col ml-n2">
                                                        <h4 className="mb-1 name">
                                                            •••• •••• ••••{" "}
                                                            {item.code}
                                                        </h4>
                                                        <p className="small mb-0">
                                                            last update{" "}
                                                            {item.updated_at}
                                                        </p>
                                                    </div>

                                                    <div className="col-auto">
                                                        <button
                                                            onClick={e => {
                                                                this.pay(
                                                                    item.id
                                                                );
                                                            }}
                                                            className="btn btn-sm btn-primary d-none d-md-inline-block"
                                                        >
                                                            Pay now
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                            <div className="model-actions">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.props.showAddCard}
                                >
                                    Add card
                                </button>
                                <button
                                    type="button"
                                    onClick={this.props.hidePay}
                                    className="btn btn-default"
                                >
                                    Close
                                </button>
                                <div className="m-3 text-muted small">
                                    You can{" "}
                                    <a
                                        href="/employer/paymentMethod"
                                        target="_blank"
                                    >
                                        manage your card
                                    </a>{" "}
                                    and view your{" "}
                                    <a href="/employer/billing" target="_blank">
                                        billing history
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Fragment>
        );
    }
}
PayModel.contextType = AppContext;
export default PayModel;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/Pay.js